<!--
 * @Author: lan.h
 * @Date: 2021-11-26 11:47:12
 * @LastEditors: lan.h
 * @LastEditTime: 2021-12-01 10:43:07
 * @Description: 申报须知
-->
<template>
  <div class="vb100">
    <div class="list-content">
      <div class="p_head" id="declare">
        <div class="p_title">
          <p>Declaration instructions</p>
          <h1>申报须知</h1>
        </div>
        <div class="p_links">
          <div class="links-item js-lower-anchor" @click="toA('#declare-relation')">
            <p class="links-name">联系我们</p>
          </div>
          <div class="links-item js-lower-anchor" @click="toA('#declare-fill')">
            <p class="links-name">资料下载</p>
          </div>
        </div>
      </div>
      <div class="declare" v-html="explain"></div>
      <div class="info" id="declare-relation">
        <div class="list-title">联系我们</div>
      </div>
      <ul class="declare-relation">
        <li v-for="item, index in contacts" :key="index">
          <div class="relation-left">
            <img :src="item.img_path | logo">
          </div>
          <div class="relation-right">
            <h1 class="over-p1">{{item.title}}</h1>
            <p>{{item.display_name}}</p>
            <p>{{item.tel}}</p>
            <p>{{item.email}}</p>
          </div>
        </li>
      </ul>
      <div class="info" id="declare-fill">
        <div class="list-title">资料下载</div>
      </div>
      <ul class="declare-fill">
        <li v-for="item, index in file" :key="index">
          <div class="fill-left">
            <img src="~/img/main/fill.png" />
          </div>
          <div class="fill-center over-p2">{{item.name}}</div>
          <div class="fill-right">
            <a :href=" $store.state.img_req_url + item.file_path" target="_blank">下载</a>
          </div>
        </li>
      </ul> 
    </div>
    <links></links>
  </div>
</template>
<script>
import { getDeclarationInstructions } from '@/service/main.js'
import { list_mixin, scroll_mixin } from 'js/list_mixins'
import links from 'mcomponents/mLinks.vue'

export default{
  mixins: [list_mixin, scroll_mixin],
  data() {
    return {
      loading: false,
      explain: '',
      contacts: [],
      file: []
    }
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta
    }
  },
  components: {links},
  created() {
    this.getDeclarationInstructions()
  },
  methods: {
    // 锚点跳转
    toA(id) {
      $("html,body").animate({ scrollTop: $(id).offset().top - 80}, 500);
    },
    async getDeclarationInstructions() {
      let res = await getDeclarationInstructions({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.explain = res.explain.length > 0 ? res.explain[0].content : ''
        this.$set(this.$data, 'contacts', res.contacts)
        this.$set(this.$data, 'file', res.file)
      } 
    },
  }
}
</script>
<style lang="stylus" scoped>
@import '~mcss/main/list.stylus';
.list-content
  width calc(100% - 1.2rem)
  margin 0 auto
  .p_head
    width 100%
    margin 0 auto
    .p_links
      right 0
      .links-item
        height .5rem
  .p_head_declare
    padding-top .8rem
  .declare
    font-size .26rem
    font-weight 500
    color #FFFFFF
    line-height .6rem
    margin-top .8rem
  #declare-relation
    margin-top .8rem
  .declare-relation
    display flex
    flex-wrap wrap
    margin-top .1rem
    li
      margin-top .3rem
      width 100%
      background #1F2330
      border-radius .1rem
      padding .3rem .2rem .3rem .3rem
      display flex
      .relation-left
        width 1.6rem
        height 1.6rem
        display flex
        justify-content space-between
        align-items center
        img 
          max-height 100%
          max-width 100%
      .relation-right
        margin-left .25rem
        h1
          font-size .26rem
          font-weight 800
          color #D9BB9E
          line-height .3rem
          margin-bottom .25rem
        p 
          font-size .24rem
          font-weight 500
          color #FFFFFF
          line-height 1
          margin-top .2rem
  #declare-fill
    margin-top .8rem
  .declare-fill
    display flex
    flex-wrap wrap
    margin-top .1rem
    margin-bottom .65rem
    li
      margin-top .3rem
      width 100%
      background #1F2330
      border-radius .1rem
      padding .2rem
      display flex
      justify-content space-between
      align-items center
      .fill-left
        width .57rem
        height .6rem
        img 
          width 100%
      .fill-center
        font-size .26rem
        font-weight 500
        color #FFFFFF
        line-height .42rem
        width 3.4rem
      .fill-right
        a
          display block
          width 1.1rem
          background linear-gradient(90deg, #D9BB9E, #C78E66)
          border-radius .04rem
          text-align center
          font-size .24rem
          font-weight 500
          color #FFFFFF
          height .46rem
          line-height .46rem
</style>